import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

// A tab's controls, rendered into the sticky page header when the page offers a slot, inline otherwise
// (tests and any host without the header). The wrapper class keeps the tab's own styles in reach.
const HeaderToolbar = ({ slot, className, children }) => (slot ? createPortal(<div className={className}>{children}</div>, slot) : children);

HeaderToolbar.propTypes = {
  slot: PropTypes.instanceOf(Element),
  className: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default HeaderToolbar;
